import {Link} from 'react-router-dom'

const Encabezado = (props: any) => {

  return (
    <>
      <div className='header-link'>
        <Link to={props.url} className='back-button w-inline-block'></Link>
        <h3 className='h3-titles xl'>Mi Perfil</h3>
      </div>
      <div className='separador'></div>
    </>
  )
}

export default Encabezado
